import React from 'react';
import { Typography } from '@ui';
import Charges from '../components/Charges';
import Payouts from '../components/Payouts';
import Statements from '../components/Statements';

export const getTabs = (showPayments, statements) => {
    const tabs = [
        {
            key: '1',
            label: (
                <Typography.Title data-e2e='invoices_charges_tab' level={3} align='center'>
                    Charges
                </Typography.Title>
            ),
            children: <Charges />
        }
    ];

    if (showPayments) {
        tabs.push({
            key: '2',
            label: (
                <Typography.Title data-e2e='invoices_payouts_tab' level={3} align='center'>
                    Payouts
                </Typography.Title>
            ),
            children: <Payouts />
        });
    }

    if (statements) {
        tabs.push({
            key: '3',
            label: (
                <Typography.Title data-e2e='invoices_statements_tab' level={3} align='center'>
                    Statements
                </Typography.Title>
            ),
            children: <Statements />
        });
    }

    return tabs;
};
